var map = {
	"./BaseWidgetForm.vue": "306b",
	"./CampListWidget.vue": "a6cc",
	"./GalleryWidget.vue": "c474",
	"./GreenLinkWidget.vue": "f2e2",
	"./HeaderWidget.vue": "8e42",
	"./ImageWidget.vue": "a62d",
	"./LogoWidget.vue": "4a1b",
	"./QuotationWidget.vue": "8824",
	"./SeeAlsoWidget.vue": "e090",
	"./SubmenuWidget.vue": "3788",
	"./TextWidget.vue": "ce64",
	"./TextWithBordersWidget.vue": "0848",
	"./TextWithTitleWidget.vue": "8aba",
	"./VideoWidget.vue": "733b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f7e1";